import { render, staticRenderFns } from "./AddressConfirmDialog.vue?vue&type=template&id=745c9a6f&"
import script from "./AddressConfirmDialog.vue?vue&type=script&lang=ts&"
export * from "./AddressConfirmDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports